import { each, get } from 'lodash';
import { hosts } from 'settings';
import countryList from 'country-list';

// TODO
// - screenName exists validation
// - move uploader to a generic component

export const ProfileFields = {
  bindings: {
    form: '<',
    member: '<',
    isEditing: '<',
    onUpdate: '&',
    onUploadComplete: '&',
  },

  template: `
    <div class="d-block d-md-flex justify-content-center" ng-hide="$ctrl.isEditing">
      <span class="d-block d-md-inline pr-4">
        <i class="fa fa-user text-teal"></i>
        {{ $ctrl.member.screenName }}
      </span>
      <span class="d-block d-md-inline pr-4">
        <i class="fa fa-envelope text-teal"></i>
        {{ $ctrl.member.email }}
      </span>
      <span class="d-block d-md-inline">
        <i class="fa fa-map-marker text-teal"></i>
        <span>{{ $ctrl.member.postcode }},</span>
        {{ $ctrl.member.country }}
      </span>
    </div>
    <div class="row" ng-show="$ctrl.isEditing">
      <div class="col-md-4 d-flex flex-column align-items-center">
        <div class="avatar avatar--lg mb-2">
          <image-circle src="$ctrl.member.profile.avatarUrl.original">
        </div>
        <label class="btn btn-link">
          <spinner is-loading="$ctrl.uploader.isUploading">
            Choose a profile picture
          </spinner>
          <input
            class="d-none"
            type="file"
            uploader="$ctrl.uploader"
            nv-file-select />
        </label>
      </div>
      <div class="col-md-8">
        <form-group-row>
          <form-group-left>
            <form-label for="screenName">
              Screen Name
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              form="$ctrl.form"
              type="text"
              name="screenName"
              value="$ctrl.member.screenName"
              pattern="[\\w\\d\\-_]+"
              required="true"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{
                required: 'This is a required field.',
                pattern: 'Only letters, numbers, dashes or underscores allowed.',
                exists: 'Screen name used by another member.',
              }">
            </form-input>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="email">
              Email
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              form="$ctrl.form"
              type="email"
              name="email"
              value="$ctrl.member.email"
              required="true"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{
                required: 'This is a required field.',
                email: 'Must be a valid email address.',
              }">
            </form-input>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="firstName">
              First Name
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              form="$ctrl.form"
              type="text"
              name="firstName"
              value="$ctrl.member.firstName"
              required="true"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }">
            </form-input>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="lastName">
              Last Name
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              form="$ctrl.form"
              type="text"
              name="lastName"
              value="$ctrl.member.lastName"
              required="true"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }">
            </form-input>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="postcode">
              Postcode
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-input
              form="$ctrl.form"
              type="text"
              name="postcode"
              value="$ctrl.member.postcode"
              required="true"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }">
            </form-input>
          </form-group-right>
        </form-group-row>
        <hr>
        <form-group-row>
          <form-group-left>
            <form-label for="country">
              Country
            </form-label>
          </form-group-left>
          <form-group-right>
            <form-select
              form="$ctrl.form"
              name="country"
              value="$ctrl.member.country"
              required="true"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              errors="{ required: 'This is a required field.' }">
              <option value="">-- Select --</option>
              <optgroup label="---------------">
                <option value="Australia">Australia</option>
                <option value="New Zealand">New Zealand</option>
              </optgroup>
              <optgroup label="---------------">
                <option
                  value="{{ country }}"
                  ng-repeat="country in $ctrl.countries track by $index">
                  {{ country }}
                </option>
              </optgroup>
            </form-select>
          </form-group-right>
        </form-group-row>
      </div>
    </div>`,

  controller($timeout, FileUploader) {
    'ngInject';

    return {
      $onInit() {
        this.countries = countryList().getNames();

        $timeout(() => {
          // Field validation on init
          each(this.form.data, (value, key) => {
            if (this.form[key]) {
              this.form[key].$setTouched();
            }
          });

          // D.O.B. field validation
          $('select.form-control').trigger('change');
        });
      },

      $onChanges() {
        if (!this.uploader) {
          this.uploader = new FileUploader({
            alias: 'member_profile[avatar]',
            autoUpload: true,
            method: 'PUT',
            onCompleteAll: () => this.onUploadComplete(),
            removeAfterUpload: true,
            withCredentials: true,
          });
        }

        if (this.member) {
          this.uploader.url = `${hosts.api}/v1/members/${
            this.member.id
          }/profile`;
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFields.js